import { useEffect, useState } from 'react';

interface Props {
  url: string;
  captions: string | null;
  /** Called when the short-lived link has expired, to fetch a fresh one */
  onExpired?: () => void;
}

/**
 * The welcome video. Captions arrive as WebVTT text and are played from a
 * local blob URL, so the track needs no cross-origin access to S3.
 */
export function WelcomePlayer({ url, captions, onExpired }: Props) {
  const [trackUrl, setTrackUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!captions) {
      setTrackUrl(null);
      return;
    }
    const blobUrl = URL.createObjectURL(new Blob([captions], { type: 'text/vtt' }));
    setTrackUrl(blobUrl);
    return () => URL.revokeObjectURL(blobUrl);
  }, [captions]);

  return (
    <video
      key={url}
      className="w-full rounded-xl bg-black aspect-video"
      controls
      playsInline
      preload="metadata"
      controlsList="nodownload"
      onError={() => onExpired?.()}
    >
      <source src={url} type="video/mp4" />
      {trackUrl && <track kind="captions" src={trackUrl} srcLang="en" label="English" default />}
    </video>
  );
}
